<div class="h-100 d-flex flex-column">
  <div class="p-2 text-black cursor-pointer w-100 d-flex justify-content-end header-color" (click)="close()">
    <span class="material-symbols-rounded" >close</span>
  </div>

  <iframe
    *ngIf="iframeSrc"
    [src]="iframeSrc"
    class="border-0 w-100 flex-grow-1"
  ></iframe>

  <div *ngIf="iframeSrcDoc" class="p-3 w-100 d-flex flex-column">
    <div class="d-flex">
      <div style="width: 90px;"><b>Subject: </b></div>
      <div>
        {{ data.outlookMessage?.subject }}
      </div>
    </div>
    <div class="d-flex">
      <div style="width: 90px;"><b>From: </b></div>
      <div *ngIf="data.outlookMessage?.from?.displayName">
        {{ data.outlookMessage?.from?.displayName }} <{{ data.outlookMessage?.from?.email }}>
      </div>
      <div *ngIf="!data.outlookMessage?.from?.displayName">
        {{ data.outlookMessage?.from?.email }}
      </div>
    </div>
    <div class="d-flex">
      <div style="width: 90px;"><b>To: </b></div>
      <ng-container *ngFor="let c of data.outlookMessage?.to">
        <div *ngIf="c.displayName" class="pr-2">
          {{ c.displayName }} <{{ c.email }}>
        </div>
        <div *ngIf="!c.displayName" class="pr-2">
          {{ c.email }}
        </div>
      </ng-container>
    </div>
    <div class="d-flex">
      <div style="width: 90px;"><b>Received On: </b></div>
      <div *ngIf="data.outlookMessage?.receivedOn">
        {{ data.outlookMessage?.receivedOn | date: 'dd/MM/yyyy' }}
      </div>
    </div>
  </div>
  <iframe
    *ngIf="iframeSrcDoc"
    [srcdoc]="iframeSrcDoc"
    class="border-0 w-100 flex-grow-1"
    sandbox
  ></iframe>

  <div
    *ngIf="!(iframeSrc || iframeSrcDoc)"
    class="h-100 w-100 d-flex justify-content-center align-items-center"
  >
    <h5>Preview unavailable, please download</h5>
  </div>
</div>
